import React from 'react'
import "./Home.css";
import Product from './Product';

function Home() {
    return (
        <div className='home'>
           <div className ="home_container">
               <img className ="home_image"
                 src="https://images-eu.ssl-images-amazon.com/images/G/02/digital/video/merch2016/Hero/Covid19/Generic/GWBleedingHero_ENG_COVIDUPDATE__XSite_1500x600_PV_en-GB._CB428684220_.jpg"
                alt="" />
<div className="home_row">
{/* product */}
<Product 
         id="123456781"
         title='The lean Startup'
         price={19.99}
         image="https://images-na.ssl-images-amazon.com/images/I/51Zymoq7UnL.AC_SY400_.jpg" 
         rating={5} 
    />
<Product
        id="123456782" 
        title="kenwood KMix Stand Mixer for Baking, Stylish Kitchen Mixer with K-beater, Dough Hook and Whisk, 5 Litre Glass Bowl"
        price={239.0}
rating={4}
image="https://m.media-amazon.com/images/I/51yd+TT6YuL._SL1200_.jpg"

/>

{/* product */}

</div>
<div className="home_row">
{/* product */
/* product */
/* product */}
<Product 
id="123456783"
title="Samsung LC49RG90SSUXEN 49' Curved LED Gaming Monitor"
price={199.99}
rating={3}
image="https://m.media-amazon.com/images/I/71nplbAMwzL._SL1202_.jpg"
/>
<Product
id="123456784"
title="Amazon Echo (3rd generatin) | Smart speaker with Alexa, Charcoal Fabric"
price={98.99}
rating={4}
image="https://m.media-amazon.com/images/I/61MbLLagiVL._SL1000_.jpg"
/>
<Product
id="123456785"
title="New Apple Ipad Pro (12.9-inch, Wi-Fi, 128GB) - silver (4th Generation)"
price={598.99}
rating={4}
image="https://images-na.ssl-images-amazon.com/images/I/816ctt5WV5L._AC_SX385_.jpg"
/>
</div>
<div className="home_row">
{/* product */}
<Product
id="123456786"
title="Samsung 34-inch (86.40cm) Curved Monitor- 21:9 Ultrawide QLED, Thunderbolt 3 Port- LC34J791WTWXXL, Gray"
price={1588.99}
rating={5}
image="https://m.media-amazon.com/images/I/91pi34PiUPL._SL1500_.jpg"
/>



</div>

           </div>
        </div>
    );
}

export default Home


